import { render, staticRenderFns } from "./latestNotifications.vue?vue&type=template&id=5311c8f9"
import script from "./latestNotifications.vue?vue&type=script&lang=js"
export * from "./latestNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports